export enum InsuranceTypeLookupValue {
  WorkersCompensation = 'Workers Compensation',
  LiabilityAndCargo = 'Liability and Cargo',
  SuretyBond = 'Surety Bond'
}

